import * as React from 'react';
import { IconProps } from '../types';

const IcSuccess = (props: IconProps) => (
  <svg width='76' height='78' viewBox='0 0 76 78' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='2.29346' width='72' height='72' rx='36' fill='#01953C' />
    <g filter='url(#filter0_d_7_28991)'>
      <rect x='10.687' y='8' width='55.213' height='56' rx='27.6065' fill='#01953C' shapeRendering='crispEdges' />
      <rect
        x='10.687'
        y='8'
        width='55.213'
        height='56'
        rx='27.6065'
        stroke='#A3E7BE'
        strokeWidth='4'
        shapeRendering='crispEdges'
      />
      <path
        d='M34.3313 46C33.7733 46 33.2431 45.7768 32.8524 45.3861L24.9555 37.4894C24.1463 36.6802 24.1463 35.3408 24.9555 34.5316C25.7647 33.7224 27.1041 33.7224 27.9133 34.5316L34.3313 40.9494L48.6738 26.6069C49.4831 25.7977 50.8224 25.7977 51.6316 26.6069C52.4408 27.4161 52.4408 28.7555 51.6316 29.5647L35.8102 45.3861C35.4196 45.7768 34.8894 46 34.3313 46Z'
        fill='white'
      />
    </g>
    <defs>
      <filter
        id='filter0_d_7_28991'
        x='0.687012'
        y='2'
        width='75.2129'
        height='76'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='4' />
        <feGaussianBlur stdDeviation='4' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
        <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_7_28991' />
        <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_7_28991' result='shape' />
      </filter>
    </defs>
  </svg>
);

export default IcSuccess;
